import { useMapStore } from "stores/map";

export function useUpdateFacilityIconSize() {
  const setDisplaySettings = useMapStore((s) => s.setDisplaySettings);

  const updateFacilityIconSize = (newSize: number) => {
    // Functional updater (EVA-63) — avoids spreading a stale render-time
    // `displaySettings` snapshot over a concurrently-applied View restore.
    setDisplaySettings((current) => ({ ...current, facilityIconSize: newSize }));
  };
  return { updateFacilityIconSize };
}
